module.exports = function(ctx) {
var __t, __p = '';
__p += '  <div class="col text-center">\n    <span>' +
((__t = ( ctx.name )) == null ? '' : __t) +
' has no preview</span>\n  </div>\n';
return __p
}